export const onEnterKeyPressHandler = (event, callback) => {
  if (event.key === 'Enter') {
    callback()
  }
}
